import { render, staticRenderFns } from "./FlipStruct.vue?vue&type=template&id=6a678bde&scoped=true&"
import script from "./FlipStruct.vue?vue&type=script&lang=js&"
export * from "./FlipStruct.vue?vue&type=script&lang=js&"
import style0 from "./FlipStruct.vue?vue&type=style&index=0&id=6a678bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a678bde",
  null
  
)

export default component.exports